module.exports = __webpack_public_path__ + "img/93.ad59192e.jpg";